export default __webpack_public_path__ + "static/media/noDataFound.012a06a3.png";